import {request} from "@/network/request";




export function getdetail(input){
    return request({
        url:'/api/show_detail/'+input

    })}

export function getRPPS(row){
    return request({
        url:'/api/show_rppsid/'+row

    })}





